import { render, staticRenderFns } from "./user_page.vue?vue&type=template&id=14cb91bc&scoped=true"
import script from "./user_page.vue?vue&type=script&lang=js"
export * from "./user_page.vue?vue&type=script&lang=js"
import style0 from "./user_page.vue?vue&type=style&index=0&id=14cb91bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cb91bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14cb91bc')) {
      api.createRecord('14cb91bc', component.options)
    } else {
      api.reload('14cb91bc', component.options)
    }
    module.hot.accept("./user_page.vue?vue&type=template&id=14cb91bc&scoped=true", function () {
      api.rerender('14cb91bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/user/user_page.vue"
export default component.exports